import {SensorsContainer} from './sensors-container';

export default {
    component: SensorsContainer
};
